module.exports = __webpack_public_path__ + "img/cloud.fb374145.svg";